import { Box, SxProps, Theme } from '@mui/material';
import { RefObject } from 'react';

const RESIZE_HANDLE_WIDTH = 8;

/**
 * The invisible drag strip a resizable chat surface puts on its edge. Hosts
 * position it: the docked chat lays it over its left edge, the side content
 * panel keeps it as the first column in its row.
 */
export function ResizeHandle({
  onMouseDown,
  resizeRef,
  sx,
}: {
  onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
  resizeRef: RefObject<HTMLDivElement | null>;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      ref={resizeRef}
      onMouseDown={onMouseDown}
      role="separator"
      aria-orientation="vertical"
      sx={{
        cursor: 'col-resize',
        flexShrink: 0,
        width: RESIZE_HANDLE_WIDTH,
        ...sx,
      }}
    />
  );
}
